import ReturnGoodsReducer from "./return-goods";
import TakingGoodsReducer from "./taking-goods";
import WarehouseInReducer from "./warehouse-in";
import WarehouseOutReducer from "./warehouse-out";

export default {
  returnGoods: ReturnGoodsReducer,
  takingGoods: TakingGoodsReducer,
  warehousein: WarehouseInReducer,
  warehouseout: WarehouseOutReducer,
};
